var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ef5826}.st4{fill:#3cddd5}.st6{fill:#26efcb}.st12{fill:#43a895}.st13{fill:#6ff2da}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3 228.5l-1 16.5 3.6.2.7-17.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.7 157.6s5.1 2.2 13.2-9.4 18.7-22.3 17.6-23.4c-6.4-6.4-28.6 4.7-32.3 14.8-3.8 10.1 1.5 18 1.5 18z",
    fill: "#12826d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2 121.4c-.6.7 5.4 15.3 13.6 23.4 8.1 8.1 13.9 12.4 16.5 10.3 2.8-2.3-2.6-18.9-14.3-28.5-11.6-9.5-15.8-5.2-15.8-5.2zM137.9 53s26.3 7.2 50.8 2.1c0 0-17 47-13.1 79.8 3.9 32.7-.2 127.1-.2 127.1h-50.2l12.7-209z",
    fill: "#1ebca0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.1 163.6c-12.2 32.9-29.8 70.6-51.1 84.7l-.8 13.7h50.2c-.1-.1 2.4-57.6 1.7-98.4z",
    opacity: 0.47,
    fill: "#3ea486"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.2 121.4s30.1 14.6 30.1 33.7l12.4-9.3s19.9-45.6 18.7-58.9c-1.2-13.3-13.9-15.4-13.9-15.4l-47.3 49.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 98.2c-9.8 14-19.4 6.7-26.5 23.3-2.1 4.9-7 9.8-12.7 14.3 5.4 5.4 9.7 12 9.7 19.3l12.4-9.3s12.7-29.1 17.1-47.6z",
    opacity: 0.24,
    fill: "#58b1af"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M152.7 157.6c-3.2 23.3-11 122-11 122-26.5-4.4-56.9-22.9-56.9-22.9l6.8-110.9s-.6-2.2 4.8-29.2c5.4-27 0-45.1 0-45.1L126.6 58l11.3-5 1.1 2.3c-.2 7 .1 15 2.1 19.9 4 10 11.6 8.5 11.6 8.5s3.3 50.6 0 73.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 83.7c1 19.4 2.1 54.2-.4 73.6-3.3 24.8-9.1 97.1-10.9 121.9-18.7-3.3-40.9-13.3-56.5-22.4 4.4 2.7 8.9 5.1 13.5 7.5 27.4 14.1 42.6 15.5 43.8 15.9 2.5-30.4 8.4-101.8 11.1-122.8 2.4-20.3.8-53.5-.6-73.7z",
    fill: "#1ea58b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.8 259s-30.8 17.6-57.4 21.2c0 0-5.5-98.9-8.2-122.3-2.7-23.4 1.7-73.9 1.7-73.9 12.8-8 15.6-20.7 15.7-30.2l9.5 4.6 31.3 15.1s-5.8 17.9-1 45.1c4.8 27.1 8.4 140.4 8.4 140.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139 60.4l-1.1-7.4 2.1-11.5s31.5 2.6 44.3 0l6.1 11.5 1.9 6.7-53.3.7z",
    fill: "#4ed1aa"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 83.7l-20.5 12.6s-8.9-22.5-7.1-33.4c.3-1.6.8-3.2 1.5-4.8 3.9-9 13.4-16.5 13.4-16.5s-.8 6.3-1 13.8c-.2 7 .1 15 2.1 19.9 4 9.8 11.6 8.4 11.6 8.4zM195 66.2c-3.2 14.4-10.2 27.5-10.2 27.5l-15-9.8c12.8-8 15.6-20.7 15.7-30.2.1-7.1-1.4-12.3-1.4-12.3s9.1 6.7 10.9 16.9c.6 2.5.6 5.1 0 7.9z",
    fill: "#a6f2ea"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 263.1c5.6-25 12.3-62.2 12.3-96.8 0-59.1-10.9-58.9-10.9-58.9-.4 2.9-.8 6-1.5 9.2-5.4 27-4.8 29.2-4.8 29.2l-6.8 110.9c.1 0 4.6 2.8 11.7 6.4zm128.9-144.6c-1.4-7.9-1.9-15.1-1.9-21.2-1.6 2-4.5 7.6-8.3 23.8-3.9 16.6 5 91.1 11.8 141.5 4.2-2.1 6.7-3.5 6.7-3.5s-3.5-113.4-8.3-140.6z",
    opacity: 0.24,
    fill: "#4ed1aa"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 73.4l45.9 51.3s-30.3 13.7-30.7 32.8l-14.1-20.4s-15.7-9.7-14-28.9c1.7-19.1 12.9-34.8 12.9-34.8z",
    fill: "#26d1cb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M227.6 137.2c-10.5-6.7-16.1-17.8-14.4-30.4 1.4-12.2 6.8-24.6 13.3-33.4-11.1 17.8-12.2 33.4-12.2 33.5-1.8 12.2 3.6 23.1 13.3 30.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M135.5 145.7l-16.3 8.3-17.3-10.6 2.3-33.6 33.6 2.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M135.1 145.3l-15.9 8-16.7-10.2c.4-5.8 1.3-21.6 1.7-33.3-1.3 13.7-2.1 25.4-2.7 33.8 9.8 6.1 7.9 4.9 17.7 11 4.7-2.4 10.9-5.6 16.8-8.7.8-13.6 1.2-20.7 1.8-33.9-.6 5.7-2.4 27.8-2.7 33.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M212.9 147.1l-15.2 10.3-18.4-8.5-1.8-33.6 33.6-1.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 55c-2.1.9-4.2 19.8 0 28s10.2 2.5 10.2 0c0-2.4-7.1-29.5-10.2-28z",
    opacity: 0.53,
    fill: "#a6f2ea"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.6 114.6l.4 3.8 19.2-.8-.1-4.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M212.4 146.8l-14.8 9.9-17.9-8.1c-.3-5.8-1.4-21.5-2.3-33.3.4 13.7 1 25.5 1.4 33.9 10.5 4.9 8.4 3.9 18.9 8.7 4.4-3 10.1-6.9 15.7-10.7-.9-13.5-1.3-20.7-2.4-33.8.2 5.7 1.1 27.9 1.4 33.4zm-64.2-49.3c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm3 31.2c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c1 0 2 .9 2 2zm-2.7 34c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-4.1 35.1c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-4.1 46.1c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM224 134.2l1.3 31c3.9 86.6 8 89.2 8.5 93.8-7.4-27.1-9.8-96.9-9.8-124.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224 84s.4 17.3 6.7 31.5 32.1 26.3 28.1 7.9c-4-18.3-34.3-52.8-34.8-39.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a3545a1ca8b73a5e93264f33721af6df.svg";
export { ForwardRef as ReactComponent };